import type { CSSProperties } from "react";

/** Dark glass tooltip styling shared by every chart in the GSC demo. */
export const TOOLTIP_CONTENT_STYLE: CSSProperties = {
  background: "#131629",
  border: "1px solid rgba(255,255,255,0.1)",
  borderRadius: 12,
  fontSize: 18,
  fontVariantNumeric: "tabular-nums",
  boxShadow: "0 12px 32px rgba(0,0,0,0.5)",
  padding: "10px 14px",
};

export const TOOLTIP_LABEL_STYLE: CSSProperties = {
  color: "rgba(255,255,255,0.65)",
  marginBottom: 4,
};

export const TOOLTIP_ITEM_STYLE: CSSProperties = {
  color: "rgba(255,255,255,0.92)",
};

/** Solid hairline gridlines, one shade off the surface. Never dashed. */
export const GRID_STROKE = "rgba(255,255,255,0.07)";

/** Recessive axis ticks. */
export const TICK_STYLE = { fill: "rgba(255,255,255,0.45)", fontSize: 18 };

export function formatNumber(v: unknown): string {
  return typeof v === "number" ? v.toLocaleString("en-US") : String(v ?? "");
}
